import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import {
  BookOpenIcon,
  NewspaperIcon,
  DatabaseIcon,
} from "@heroicons/react/outline";

import { classNames } from "helpers";

interface Props {
  className?: string;
}

export const SidebarNavigation = ({ className }: Props) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <nav className={className}>
      {navigation.map((item) => (
        <button
          key={item.name}
          onClick={() => history.push(item.href)}
          className={classNames(
            location.pathname.includes(item.href)
              ? "bg-gray-100 text-gray-900"
              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
            "group flex items-center px-2 py-2 text-sm font-medium rounded-md cursor-pointer w-full"
          )}
        >
          <item.icon
            className={classNames(
              location.pathname.includes(item.href)
                ? "text-gray-500"
                : "text-gray-400 group-hover:text-gray-500",
              "mr-3 flex-shrink-0 h-6 w-6"
            )}
            aria-hidden="true"
          />
          {item.name}
        </button>
      ))}
    </nav>
  );
};

const navigation = [
  { name: "Pages", href: "/pages", icon: DatabaseIcon, current: true },
  { name: "Recipes", href: "/recipes", icon: BookOpenIcon, current: true },
  { name: "Articles", href: "/articles", icon: NewspaperIcon, current: true },
  { name: "Reviews", href: "/reviews", icon: NewspaperIcon, current: true },
];
